import { EntityService } from './EntityService';
import { IEntity, INAODefForm } from '../types';

export class AvailableAppService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/AvailableApps`);
    }
    public readAllForLookup(includeClosed?: boolean): Promise<IEntity[]> {
        return this.readAll();
    }

    // public readAllForSector(sectorID: number): Promise<IEntity[]> {
    //     return this.readAll(`GetAppsForSector?sectorID=${sectorID}`);
    // }

    public readAvailableAppsWithFilters(
        editionID: number,
        systemSectorID: number,
        systemCountryID: number
    ): Promise<IEntity[]> {

        const qs = `GetAvailableAppsWithFilters?editionID=${editionID}&systemSectorID=${systemSectorID}&systemCountryID=${systemCountryID}`;
        return this.readAll(qs);
    }
}